import React, {useState} from 'react';
import Input from "../UI/Input";
import Button from "../UI/Button";
import {useNavigate} from "react-router-dom";

const AskResetForm = ({onSubmit}) => {

    const [email, setEmail] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();

        onSubmit && onSubmit(email);
    }

    return (
        <div>
            <form onSubmit={handleSubmit} className="mx-4 p-4 bg-ea_green_from rounded-lg mt-4 flex flex-col ">
                <div>Invia il codice di reset alla tua email.</div>
                <Input label="Email" type="email" name="email" placeholder="Inserisci la tua email"
                       onChange={e => setEmail(e.target.value)}/>
                <Button type="submit" className="text-black mt-4">Resetta la password</Button>
            </form>
        </div>
    );
};

export default AskResetForm;